import React, { createContext, useContext, useReducer } from 'react';

const CartContext = createContext();

function cartReducer(state, action) {
  switch (action.type) {
    case 'ADD': {
      const existing = state.items.findIndex(i => i.product_id === action.product.id);
      if (existing >= 0) {
        const items = [...state.items];
        items[existing] = { ...items[existing], quantite: items[existing].quantite + 1 };
        return { ...state, items };
      }
      return {
        ...state,
        items: [...state.items, {
          product_id: action.product.id,
          nom: action.product.nom,
          prix: action.product.prix_ttc,
          stand_id: action.product.stand_id,
          stand_nom: action.product.stand_nom,
          quantite: 1,
        }],
      };
    }
    case 'REMOVE': {
      return { ...state, items: state.items.filter(i => i.product_id !== action.product_id) };
    }
    case 'UPDATE_QTY': {
      if (action.quantite <= 0) {
        return { ...state, items: state.items.filter(i => i.product_id !== action.product_id) };
      }
      return {
        ...state,
        items: state.items.map(i =>
          i.product_id === action.product_id ? { ...i, quantite: action.quantite } : i
        ),
      };
    }
    case 'CLEAR':
      return { ...state, items: [] };
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [cart, dispatch] = useReducer(cartReducer, { items: [] });
  const total = cart.items.reduce((sum, i) => sum + i.prix * i.quantite, 0);
  const count = cart.items.reduce((sum, i) => sum + i.quantite, 0);

  return (
    <CartContext.Provider value={{ cart, dispatch, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
